<mat-toolbar color="primary" class="custom-header">
  <button mat-icon-button (click)="guiService.goTo('main/home')">
    <mat-icon svgIcon="mat:chevron_left"></mat-icon>
  </button>
</mat-toolbar>
<div class="container" *ngIf="!pageSpinner">
  <div class="top-title">
    <h2>{{"ADDONS.SHOP" | translate}}</h2>
    <h2>{{"ADDONS.TOTAL" | translate}} <span>{{totalAmount | number:'1.2-2'}} $</span></h2>
  </div>
  <div class="element" *ngFor="let item of addons">
    <div class="item" (click)="addonDetail(item)">
      <div class="img-area">
        <img [src]="item.imgUrl">
      </div>
      <div class="content-area">
        <p class="addon-name">{{item.i18nName[translate.currentLang.toUpperCase()]}}</p>
        <p class="description">
          {{item.i18nDescription[translate.currentLang.toUpperCase()]}}
        </p>
        <div class="price-area">
          <p class="price old-price" *ngIf="item?.oldPrice && item?.oldPrice !== ''">
            {{item.oldPrice + item.currency}}
            <span class="bar-override"></span>
          </p>
          <p class="price">{{item.price + item.currency}}</p>
        </div>
      </div>
    </div>
    <div class="amount">
      <mat-icon svgIcon="mat:do_not_disturb_on" [class.btn-disabled]="item.quantity.count === 0"
        (click)="addQuantity(item, 'minus')"></mat-icon>
      <span class="count">
        {{item.quantity.count}}
      </span>
      <mat-icon svgIcon="mat:add_circle" [class.btn-disabled]="item.quantity.count === item.quantity.max"
        (click)="addQuantity(item, 'plus')"></mat-icon>
    </div>
  </div>
</div>
<div *ngIf="pageSpinner" class="page-spinner">
  <mat-icon><mat-spinner color="warn" diameter="20"></mat-spinner></mat-icon>
</div>
<div class="footer-position" *ngIf="!pageSpinner">
  <button class="its-button" *ngIf="!purchaseSpinner" [disabled]="totalAmount === 0"
    (click)="openModalConfirmPurchase()">{{"GENERIC.CONTINUE" | translate}}</button>
  <button class="its-button" *ngIf="purchaseSpinner">
    <mat-icon><mat-spinner color="warn" diameter="20"></mat-spinner></mat-icon>
  </button>
</div>
